/**
 * "UCP"-Button - fest im unteren Bereich der Navigation verankert, direkt
 * unter "Das Ende" (siehe Sidebar.tsx für Desktop und MobileDrawer.tsx für
 * Smartphone/Tablet). Bewusst KEIN viewport-fixiertes Overlay - sitzt als
 * normales Flow-Element ausschließlich in diesen beiden Navigationsspalten,
 * niemals lose über anderen Seiteninhalten. Öffnet das Retro Roleplay UCP
 * in einem neuen Tab, damit die aktuelle Website geöffnet bleibt. Visuelle
 * Umsetzung (Neon-Glow) siehe .ucp-neon-btn in styles/index.css.
 */
export function UcpButton() {
  return (
    <a
      href="https://retro-roleplay.ch/portal"
      target="_blank"
      rel="noopener noreferrer"
      className="ucp-neon-btn"
      aria-label="Retro Roleplay UCP öffnen (neuer Tab)"
    >
      UCP
    </a>
  );
}
